// extracted by mini-css-extract-plugin
module.exports = {"MoneyRange":"MoneyRange_MoneyRange__2t10f","isNoWrap":"MoneyRange_isNoWrap__2DSZA"};